import React, { useState, useEffect } from 'react';
import { Input, Grid } from '@mui/material';
import { JsonView, allExpanded, defaultStyles } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';
import {
  FluxButton, FluxAccordion, FluxTable
} from '@meltwater/flux-web-components-react';
import { useCompanyId } from '../../services/CompanyidProvider';
import apiServiceCompany from '../../services/company.services';
import { FluxTooltip } from '@meltwater/flux-web-components-react';
import styles from './company.module.css';
const def_record = {
  _id: "",
  opportunityId: 0,
  name: "No Company Loaded",
  country: "",
  overrides: {
    sendReports: false,
    allowUserLogin: false,
    canUnsubscribe: false,
    twitterContentRestricted: false
  },
  created: "",
  modified: "",
  ssoRequired: false
}

function CompanyPrompt() {
  const [userInput, setUserInput] = useState('');
  const {companyId, setCompanyId } = useCompanyId();
  const [companyName, setCompanyName] = useState('No Company Loaded');;
  const [isExpanded, setIsExpanded] = useState(false);
  const [companyInfo, setCompanyInfo] = useState(def_record);
  
  const handleInputChange = (event) => {
    setUserInput(event.target.value);
  };
  useEffect(() => {
    // You can access and update the company ID here
    if (companyId) {
     
      console.log("Fetching company from Server ")
      async function fetchData() {
        try {

          const company = await apiServiceCompany.getCompany(companyId);
          console.log(`Current Company ID: ${companyId}`, company);
          if (company.status === 'ok'){        
              setCompanyName(company.data.name)
              setCompanyInfo(company.data)
              localStorage.setItem('companyData', JSON.stringify(company));
   // }
           }
           else
           {
            console.log(`Invalid Company - Enter a valid Company Entered`);
            setCompanyName("Invalid Company - Enter a valid Company")
            setCompanyInfo(def_record);
             setCompanyId("")
           }
      
        } catch (error) {
          console.log(`FAIL`,error);
          setCompanyName("Invalid Company - Enter a valid Company")
          setCompanyInfo(def_record);
          // localStorage.setItem('companyData', JSON.stringify(def_record));
           // setCompanyId("")
           setCompanyId("");
        }
      }
      
      fetchData();
    
    }
    else {
      setCompanyName("No Company Loaded");
      setCompanyInfo(def_record);
    }
  }, [companyId,setCompanyId]);

  const handleSubmit = () => {
    setCompanyId(userInput);
   // setIsExpanded(!isExpanded)
   // refresh the page when update company
    window.location.reload();
  };
 
  
  return (
    <div className={styles.Company}>
   <div className={styles.Appheader}>
    <Grid container >
    <Grid item xs={12}  >
      <FluxAccordion
        summary={companyId ? `Current Company: ${"" || companyName}    ${companyId}` : 'Click here to load a company'}
        open={isExpanded}
        onFlux-hide={(() => setIsExpanded(false))}
        onFlux-show={(() => setIsExpanded(true))}
   
        
      >
       
       {!isExpanded && <FluxTooltip placement='top'> Select to change Company </FluxTooltip>}
        <Grid container>
          <Grid item xs={4} xl={3}>
            <JsonView data={companyInfo} allExpanded shouldInitiallyExpand={allExpanded} style={defaultStyles} />

          </Grid>
          <Grid item >
          {/* <JsonView data={companyEntitletment} allExpanded shouldInitiallyExpand={allExpanded} style={defaultStyles} /> */}
         
          </Grid>
        </Grid>
        <FluxTable>

        </FluxTable>
        <Grid container>
          <Grid item xs={4} xl={3}>
            <Input fullWidth placeholder="Enter Companyid" type="text" value={userInput} onChange={handleInputChange} />
          </Grid>
          <Grid  item xs={4} xl={3} >
            <FluxButton tint='primary' type="filled"  onClick={handleSubmit}>Load Company</FluxButton>
            <FluxTooltip placeholder='top'>Load Entered Company</FluxTooltip>
          </Grid>
          <Grid item >
          </Grid>
        </Grid>
      </FluxAccordion>
      </Grid>
      </Grid>


    </div>
    </div>
  );
}

export default React.memo(CompanyPrompt);